import {
	CREATE_PRODUCER,
  CREATE_PRODUCER_SUCCESS,
	CREATE_PRODUCER_FAIL,
} from "./Constants"

const initialState = {
		isLoading: false,
		error: null,
		data: null
}
export default function reducer(state = initialState, action) {
	switch(action.type) {
		case CREATE_PRODUCER:
			return {
				...state,
				isLoading: true
			}
		case CREATE_PRODUCER_SUCCESS:
			return {
				...state,
				isLoading: false,
				data: action.payload
			}
		case CREATE_PRODUCER_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.payload
			}
		default:
			return state;
	}
}